exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.gridtable {\n  width: 80%;\n  text-align: center;\n  font-family: verdana,arial,sans-serif;\n  font-size:11px;\n  color:#333333;\n  border-width: 1px;\n  border-color: #666666;\n  border-collapse: collapse;\n}\ntable.gridtable th {\n  border-width: 1px;\n  padding: 8px;\n  border-style: solid;\n  border-color: #ebe5e5;\n  background-color: #dedede;\n}\ntable.gridtable td {\n  border-width: 1px;\n  padding: 8px;\n  border-style: solid;\n  border-color: #ebe5e5;\n  background-color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a5063598","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/view/sharer/tongji/jingying.vue
// module id = 1657
// module chunks = 0